import { DecoratorPlaceholder, DecoratorWrapper } from './atoms';
import { InlineUserAvatar } from './UserAvatar';
import { LinkDecorator } from './LinkDecorator';

type UserDecoratorProps = {
  name?: string;
  email?: string;
  image?: string;
  placeholder?: string;
  underlineOnHover?: boolean;
  color?: string;
};

export const UserDecorator = ({
  name,
  email,
  image,
  placeholder,
  underlineOnHover,
  color,
}: UserDecoratorProps) => (
  <DecoratorWrapper>
    <InlineUserAvatar image={image} />
    {email && (
      <LinkDecorator
        hideIcon
        underlineOnHover={underlineOnHover}
        href={email ? `mailto:${email}` : undefined}
        target="_blank"
        color={color}
      >
        {name || email}
      </LinkDecorator>
    )}
    {name && !email && name}
    {!name && !email && (
      <DecoratorPlaceholder>{placeholder || 'Unknown'}</DecoratorPlaceholder>
    )}
  </DecoratorWrapper>
);
